import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import { Box, Typography } from '@mui/material'
import Button from '@rentspree/component-2023.components.atoms.button'
import { Dialog } from '@rentspree/component-2023.components.atoms.dialog'

import { useDispatch, useSelector } from 'store'

import { hideAlertDialog } from '../../store/alert-dialog'

const ICON_BY_TYPE = {
  success: <CheckCircleIcon sx={{ fontSize: '48px', color: '#1A962F' }} />,
  error: <ErrorIcon sx={{ fontSize: '48px', color: '#D11717' }} />,
}

// TODO: TECH-28352 -> Handle style according to UIKit
export const AlertDialog = () => {
  const { open, message, type, title, ctaTitle } = useSelector((state) => state.alertDialog)
  const dispatch = useDispatch()

  if (!open) return null

  const icon = ICON_BY_TYPE[type]
  return (
    <Dialog scroll="paper" open={open} onClose={() => dispatch(hideAlertDialog())}>
      <Box sx={{ padding: '24px', gap: '16px', display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          {icon}
          <Typography variant="title-large">{title}</Typography>
          <Typography sx={{ justifyContent: 'center', textAlign: 'center' }}>{message}</Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatch(hideAlertDialog())
            }}
          >
            {ctaTitle}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
